 //$(window).on('load', function(){
 $(document).ready(function() { 
$(document).on('click', '.quick-new-popup label', function () {
  let $this = $(this);
  var data_id = $(this).parents('.product-quick-view').attr('data-product-id');
  console.log('data_id',data_id)
    setTimeout(function(){
    var data_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-button');
     // var data_save_label_text = $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection .quick-new-popup input:checked').attr('data-plan-name');
     var data_save_label_text = $this.parent().find('input').attr('data-plan-name');
      console.log('data_save_label_text',data_save_label_text)
      if(data_save_label_text == '6 Month Prepaid Plan'){
        var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-recur-price');
      }
      else if(data_save_label_text == 'Monthly Subscription'){
        setTimeout(function(){
          var data_five_main_price = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-main-five-price')
          $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-price.subscribe-btn-clicked').text(data_five_main_price);
        }, 100);
        var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-discount-five-save-price');
        // var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-recur-price');
      }
      else{
      var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-saved-amt');
    }
      console.log('data_save_label',data_save_label)
      $('.ttl-savings span').text(data_save_label)
      console.log('iff');
if(data_label == ''){
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.btn-wrap').show()
         $('.product-quick-view[data-product-id="'+data_id+'"]').find('.amazone-pay-button').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.header-pricing-wrapper').show()
  $('.product-quick-view[data-product-id="'+data_id+'"]').find('.pricing-wrapper').show()

    console.log('iffm');
    }else{
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.amazone-pay-button').show()
         $('.product-quick-view[data-product-id="'+data_id+'"]').find('.btn-wrap').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.pricing-wrapper').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.header-pricing-wrapper').hide()


         $(".amazone-pay-button a").attr("href", data_label);
    console.log('iffs');
    }
      $('.product-quick-view[data-product-id="'+data_id+'"]').find('.medium-down--show.hide.ttl-savings span').text(data_save_label);
    }, 500);


   setTimeout(function(){
    var data_col = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-col-sub');
    console.log('iff');
       var ship_price = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('ship-price');
      var ship_compare = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('ship-compare');
    var ship = $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection .quick-new-popup input:checked').attr('ship');
console.log('ship',ship)
      if(ship == 6){
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product--compare-at').text(ship_compare)
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-price').text(ship_price)
      }
if(data_col == 'true'){
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection').show()
    console.log('iffm');
    }else{
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection').hide()
    console.log('iffs');
    }
    }, 150);
});
$(document).on('click', '.quick-radio', function () {
    var data_id = $(this).parents('.product-quick-view').attr('data-product-id');
  console.log('iff',data_id);
    setTimeout(function(){
    var data_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-button');
     var data_save_label_text = $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection .quick-new-popup input:checked').attr('data-plan-name');
     console.log('data_save_label_text',data_save_label_text)
      if(data_save_label_text == '6 Month Prepaid Plan'){
      var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-recur-price');
      }else if(data_save_label_text == 'Monthly Subscription'){
        setTimeout(function(){
        var data_five_main_price = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-main-five-price')
      $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-price.subscribe-btn-clicked').text(data_five_main_price);
        }, 100);
      var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-discount-five-save-price');
    }else{
      var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-saved-amt');
    }
      console.log('iff');
if(data_label == ''){
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.btn-wrap').show()
         $('.product-quick-view[data-product-id="'+data_id+'"]').find('.amazone-pay-button').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.header-pricing-wrapper').show()
  $('.product-quick-view[data-product-id="'+data_id+'"]').find('.pricing-wrapper').show()

    console.log('iffm');
    }else{
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.amazone-pay-button').show()
         $('.product-quick-view[data-product-id="'+data_id+'"]').find('.btn-wrap').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.pricing-wrapper').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.header-pricing-wrapper').hide()


         $(".amazone-pay-button a").attr("href", data_label);
    console.log('iffs');
    }
       $('.product-quick-view[data-product-id="'+data_id+'"]').find('.medium-down--show.hide.ttl-savings span').text(data_save_label);
 
    }, 150);


   setTimeout(function(){
    var data_col = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-col-sub');
    console.log('iff');
       var ship_price = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('ship-price');
      var ship_compare = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('ship-compare');
    var ship = $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection .quick-new-popup input:checked').attr('ship');
console.log('ship',ship)


     var data_save_label_text = $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection .quick-new-popup input:checked').attr('data-plan-name');
     console.log('data_save_label_text',data_save_label_text)
      if(data_save_label_text == '6 Month Prepaid Plan'){
      var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-recur-price');
      }else if(data_save_label_text == 'Monthly Subscription'){
        setTimeout(function(){
        var data_five_main_price = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-main-five-price')
      $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-price.subscribe-btn-clicked').text(data_five_main_price);
        }, 100);
      var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-discount-five-save-price');
    }else{
      var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-saved-amt');
    }
     
      if(ship == 6){
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product--compare-at').text(ship_compare)
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-price').text(ship_price)
      }
if(data_col == 'true'){
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection').show()
    console.log('iffm');
    }else{
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection').hide()
    console.log('iffs');
    }
    }, 150);
})

   $('.product-quick-view').each(function(){
    var data_id = $(this).attr('data-product-id');
    setTimeout(function(){
    var data_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-button');
    console.log('iff');
if(data_label == ''){
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.btn-wrap').show()
         $('.product-quick-view[data-product-id="'+data_id+'"]').find('.amazone-pay-button').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.header-pricing-wrapper').show()

    console.log('iffm');
    }else{
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.amazone-pay-button').show()
         $('.product-quick-view[data-product-id="'+data_id+'"]').find('.btn-wrap').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.pricing-wrapper').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.header-pricing-wrapper').hide()

         $('.product-quick-view[data-product-id="'+data_id+'"]').find(".amazone-pay-button a").attr("href", data_label);
    console.log('iffs');
    }
    }, 150);
})

   $(document).on('click', '.product-info .more-info .product-cart.btn', function () {
$('.quick-new-popup:first-child label').trigger('click');

  $('.product-quick-view').each(function(){
    var data_id = $(this).attr('data-product-id');
    setTimeout(function(){
    var data_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-button');
    console.log('iff');
if(data_label == ''){
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.btn-wrap').show()
         $('.product-quick-view[data-product-id="'+data_id+'"]').find('.amazone-pay-button').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.header-pricing-wrapper').show()

    console.log('iffm');
    }else{
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.amazone-pay-button').show()
         $('.product-quick-view[data-product-id="'+data_id+'"]').find('.btn-wrap').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.pricing-wrapper').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.header-pricing-wrapper').hide()

         $('.product-quick-view[data-product-id="'+data_id+'"]').find(".amazone-pay-button a").attr("href", data_label);
    console.log('iffs');
    }
    }, 150);
})
  
});

   $(document).on('click', '.quick-radio', function () {
    var data_id = $(this).parents('.product-quick-view').attr('data-product-id');

  setTimeout(function(){
    var data_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-button');
      var ship_price = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('ship-price');
      var ship_compare = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('ship-compare');
    var ship = $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection .quick-new-popup input:checked').attr('ship');
console.log('ship',ship)
    var data_save_label_text = $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection .quick-new-popup input:checked').attr('data-plan-name');
     console.log('data_save_label_text',data_save_label_text)
      if(data_save_label_text == '6 Month Prepaid Plan'){
      var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-recur-price');
      }else if(data_save_label_text == 'Monthly Subscription'){
        setTimeout(function(){
        var data_five_main_price = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-main-five-price')
      $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-price.subscribe-btn-clicked').text(data_five_main_price);
        }, 100);
      var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-discount-five-save-price');
    }else{
      var data_save_label = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-saved-amt');
    }
      if(ship == 6){
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product--compare-at').text(ship_compare)
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-price').text(ship_price)
      }
      console.log('iff');
if(data_label == ''){
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.btn-wrap').show()
         $('.product-quick-view[data-product-id="'+data_id+'"]').find('.amazone-pay-button').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.header-pricing-wrapper').show()
  $('.product-quick-view[data-product-id="'+data_id+'"]').find('.pricing-wrapper').show()

    console.log('iffm');
    }else{
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('.amazone-pay-button').show()
         $('.product-quick-view[data-product-id="'+data_id+'"]').find('.btn-wrap').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.pricing-wrapper').hide()
$('.product-quick-view[data-product-id="'+data_id+'"]').find('.header-pricing-wrapper').hide()


         $(".amazone-pay-button a").attr("href", data_label);
    console.log('iffs');
    }
    }, 150);

  
})
   
    var data_id = $(this).parents('.product-quick-view').attr('data-product-id');
    setTimeout(function(){
    var data_col = $('.product-quick-view[data-product-id="'+data_id+'"]').find('.product-single__variants option:selected').attr('data-col-sub');
    console.log('iff');
if(data_col == 'true'){
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection').show()
    console.log('iffm');
    }else{
        $('.product-quick-view[data-product-id="'+data_id+'"]').find('#recurpay-widget-collection').hide()
    console.log('iffs');
    }
    }, 150);
   
$(".grid-product").each(function() {
    var data_col_id = $(this).attr('product-id');
    var data_c_btn = $('.grid-product[product-id="'+data_col_id+'"]').find('.custom-option input').attr('data-c');
    console.log('iff');
if(data_c_btn == 'true'){
$('.grid-product[product-id="'+data_col_id+'"]').find('.col-subscription-button').show()
        $('.grid-product[product-id="'+data_col_id+'"]').find('.col-explore-button').hide()


    console.log('iffm');
    }
else{
 $('.grid-product[product-id="'+data_col_id+'"]').find('.col-explore-button').show()
        $('.grid-product[product-id="'+data_col_id+'"]').find('.col-subscription-button').hide()

    console.log('iffs');
    }

 });

   
  var lastScrollTop = 0;
    var header = $('#shopify-section-header');
     var nav_head = $('.additional-nav-wrapper');

    $(window).scroll(function(event){
        var st = $(this).scrollTop();
        var inner_h = header.innerHeight();
      $('.additional-nav-wrapper').css({"top":inner_h})
        // Scroll down
        if (st > lastScrollTop){
            // Scroll down action
            header.removeClass('sticky');
          nav_head.removeClass('sticky');
        } else {
            // Scroll up action
            header.addClass('sticky');
          nav_head.addClass('sticky');
        }
        
        lastScrollTop = st;
    });
     
  $(document).on('change', '.cart-form-reload-wc input.js-qty__num', function(e){
    e.preventDefault();
    console.log('ifff')
    setTimeout(function(){
      $('.cart-form-reload-wc').load(' .cart-form-reload-wc', function(){
      });
    }, 500)
  })

    $(document).on('change', '.cart-form-reload-wc .js-qty__adjust', function(e){
    e.preventDefault();
    console.log('ifff')
    setTimeout(function(){
      $('.cart-form-reload-wc').load(' .cart-form-reload-wc', function(){
      });
    }, 500)
  })

     $(document).on('click', '.amazone-pay-button', function(){
        var data_btn = $(this).parents('.product-quick-view').find('.product-single__variants option:selected').attr('data-button');
      var variantId = $(this).parents('.product-quick-view').find('.product-single__variants option:selected').attr('data-variant');
      var productId = $(this).parents('.product-quick-view').find('.product-single__variants option:selected').attr('data-product');
      var productName = $(this).parents('.product-quick-view').find('.product-single__variants option:selected').attr('data-title');
      var brandName = $(this).parents('.product-quick-view').find('.product-single__variants option:selected').attr('data-brand');
      var price = $(this).parents('.product-quick-view').find('.product-single__variants option:selected').attr('data-price');
      var sku = $(this).parents('.product-quick-view').find('.product-single__variants option:selected').attr('data-sku');

      console.log('amazone',[`shopify_IN_${productId}_${variantId}`]);
      console.log('amazone',`shopify_IN_${productId}_${variantId}`);
      console.log('amazone',price,variantId,productId,data_btn);
      console.log('amazone',productName);
      console.log('amazone',brandName);
      console.log('amazone',sku);

      // dataLayer.push({
      //     event: "shop_from_amazon",
      //     eventModel: {
      //       ecomm_prodid: [`shopify_IN_${productId}_${variantId}`],
      //       ecomm_totalvalue: parseInt(price),
      //       ecomm_pagetype: "product",
      //       value: price,
      //       current_page_url: window.location.href,
      //       currency: "INR",
      //       items: [{
      //         item_id: `shopify_IN_${productId}_${variantId}`,
      //         item_name: productName,
      //         item_brand: brandName,
      //         item_category: "",
      //         price: price,
      //         quantity: 1,
      //         item_variant: sku
      //       }]
      //     }
      // })
     })

   
     console.log('testtt')
    $(document).on('click','.tab-link > li > a',function(){
      $('.tab-link > li > a').removeClass('active');
      $(this).addClass('active');
      var tagid = $(this).data('tag');
      $('.panel-group > .tab-panel').removeClass('active');
      $('.panel-group > #'+tagid).addClass('active');
    });
    
    $('.accordion-set').each(function(i,e){
      var $this = $(this);
      $(this).find('a').click(function(){
        $this.siblings().find('a').removeClass('active');
        $(this).toggleClass('active');
        var tagid = $(this).data('tag');
        $('.accordion-set  > #'+tagid).toggle(250);
        $('.accordion-set  > .accordion-panel').not( '#'+tagid ).hide(250);
      });
    });
  })
 document.addEventListener("DOMContentLoaded", function() {
  const images = document.querySelectorAll('img[loading="lazy"]');
  images.forEach(img => {
    img.removeAttribute('loading');
  });
});


$(document).ready(function(){
  $('.new-blog-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow blog-slide-arrow-left"><img src="https://cdn.shopify.com/s/files/1/0256/0861/8029/files/Path_11747_3x_ec9b3d2f-a22b-45f0-9f76-d791435e3da3.png?v=1712900071"></button>',
    nextArrow: '<button class="slide-arrow next-arrow blog-slide-arrow-right"><img src="https://cdn.shopify.com/s/files/1/0256/0861/8029/files/Path_11747_3x_ec9b3d2f-a22b-45f0-9f76-d791435e3da3.png?v=1712900071"></button>',
      fade: false,
      adaptiveHeight: true,
      initialSlide: 0,
      infinite: true,
      arrows: true,
     responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots:true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots:true
      }
    }
  ]
    });
})